import { Link } from "react-router-dom";

export default function NotAuth() {

   return (
      <div className="d-flex align-items-center justify-content-center vh-100">
         <div className="text-center">
            <h1 className="display-1 fw-bold">403</h1>
            <p className="fs-3"> <span className="text-danger">Opps!</span> not your page.</p>
            <p className="lead">
               The page you’re looking is above your rank.
            </p>
            <Link to='/' className="btn btn-primary">Go Home</Link>
         </div>
      </div>
   )
}
